import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

const HeroSection = ({ isDarkMode }) => {
  return (
    <section className="hero-section">
      <div className="hero-container">
        <div className="hero-content-wrapper">
          <motion.div 
            className="hero-content"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1>
              <span className="gradient-text">All AI Models.</span>
              <br />Only One Subscription.
            </h1>
            <p className="hero-subtitle">
              Access OpenAI's GPT-5, Claude Sonnet 4.5, Gemini 3, and more for less than the price of a single service.
              <br />Switch between models instantly. Compare results. Unlimited usage.
            </p>
            
            <div className="app-store-buttons">
                <a 
                  href="https://apps.apple.com/us/app/arrowai-ai-chatbot-assistant/id6618111835" 
                  className="app-store-button"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img 
                    src="/app-store.svg" 
                    alt="Download on the App Store" 
                  />
                </a>
              </div>
            <motion.div 
              className="cta-button-container"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.5, duration: 0.5 }}
            >
              <a href="/signup" className="primary-button">
                Try For Free <ArrowRight size={18} />
              </a>
              <p className="no-credit-card">No credit card required</p>
            </motion.div>
          </motion.div>
          
          <motion.div 
            className="hero-screenshot"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.8 }}
            whileHover={{ 
              y: -15, 
              rotate: -2,
              transition: { duration: 0.3 }
            }}
          >
            <motion.div 
              className="screenshot-content"
              animate={{ 
                y: [0, -10, 0],
                rotate: [-5, -6, -5]
              }}
              transition={{ 
                repeat: Infinity, 
                duration: 6,
                ease: "easeInOut"
              }}
            >
              <img 
                src={isDarkMode ? "/dark_mode_app_screenshot.jpeg" : "/light_mode_app_screenshot.jpeg"} 
                alt="Arrow.AI interface" 
              />
            </motion.div>
            <div className="screenshot-glow"></div>
          </motion.div>
        </div>
      </div>
      
      <div className="hero-background">
        <div className="gradient-blob blob-1"></div>
        <div className="gradient-blob blob-2"></div>
        <div className="gradient-blob blob-3"></div>
      </div>
    </section>
  );
};

export default HeroSection;